
import { useEffect } from 'react';
import { useMaterialUIController, setShopingCart } from "context";

const formatter = currency => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: currency || 'USD',
});

const useCart = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { cart } = controller;

  const itemQuantity = list =>list.reduce((acc, obj) => acc + obj.quantity, 0);

  const cartTotal    = list => {
    if (cart.items.length === 0 ) return 0;
    const priceTotal =  list.reduce((total, item) => {
      const price = item.price.sold && item.price.sold !== 0 ? item.price.sold : item.price.original
      return total + cart.items.find( i => i.id === item.id )?.quantity  * Number(price) ;
    }, 0);
    return formatter('DZD').format(priceTotal)
  }   

  const cartNumberTotal    = list => {
    if (cart.items.length === 0 ) return 0;
    const priceTotal =  list.reduce((total, item) => {
      const price = item.price.sold && item.price.sold !== 0 ? item.price.sold : item.price.original
      return total + cart.items.find( i => i.id === item.id )?.quantity  * Number(price) ;
    }, 0);
    return priceTotal
  }   

  const addItem = newItem => {
    const foundItem = cart.items.find(item=>item.id === newItem.id);
    if( foundItem ){     
      if(newItem?.details){
        foundItem.details  = newItem.details;
        foundItem.quantity = newItem.quantity;
      }else{
        foundItem.quantity += newItem.quantity;
      }
      if(newItem?.colors) foundItem.colors   = newItem.colors;
      return setShopingCart(dispatch, {items : cart.items, quantity : itemQuantity(cart.items)})
    }
    return setShopingCart(dispatch, {items : [...cart.items, newItem], quantity : itemQuantity([...cart.items, newItem])})
  }

  const removeItem = newItem => {
    let list;
    if( cart.items.find(item=>item.id === newItem.id)?.quantity === 1 || newItem.quantity === 0 ){
        list = cart.items.filter(item => item.id !== newItem.id) ;
        return setShopingCart(dispatch, { items : list, quantity : itemQuantity(list)}) 
    }
    if(cart.items.find(item=>item.id === newItem.id)) {
      cart.items.find(item=>item.id === newItem.id).quantity -= newItem.quantity;
    } 
    return setShopingCart(dispatch, { items : cart.items, quantity : itemQuantity(cart.items)}) 
  }

  const emptyCart = () => setShopingCart(dispatch, { items : [], quantity : 0 }) ;

  useEffect(() => localStorage.setItem('shoping-cart',JSON.stringify(cart)), [cart])
  
  return { cart, addItem, removeItem, cartTotal, cartNumberTotal, emptyCart }
}

export default useCart